import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { useAddMeasure } from "../../api/hooks/allHooks";
import { normalRetrofitDataToPerM2 } from "../../utils/general";
import { BuildingArea } from "../BuildingProfile/types";
import { FormField } from "../DynamicForm";
import ItemPopUpForm, { MutateInputs } from "../ItemPopUpForm";

type CreatRetrofitMeasureFormProps = {
  building: BuildingArea;
  formItems: FormItem[];
  isOpen: boolean;
  isPerM2: boolean;
  projectId: number | string;
  requiredFields?: string[];
  setIsOpen: (isOpen: boolean) => void;
};

type FormItem = FormField & { optionsFn?: (formData: Record<string, unknown>) => string[] };

const CreatRetrofitMeasureForm: React.FC<CreatRetrofitMeasureFormProps> = ({
  building,
  formItems,
  isOpen,
  isPerM2,
  projectId,
  requiredFields,
  setIsOpen,
}) => {
  const { t } = useTranslation();
  const { user } = useSelector((store: any) => store.user);

  const { isLoading, mutate: addMeasure } = useAddMeasure();

  const mutate = (props: MutateInputs) => {
    const { data, ...rest } = props;
    const perM2Data = isPerM2 ? data : normalRetrofitDataToPerM2({ building, retrofitData: data });
    addMeasure({
      data: { ...perM2Data, project: projectId, user: user?.user_id },
      ...rest,
    });
  };

  return (
    <ItemPopUpForm
      formItems={formItems}
      initialFormData={{}}
      isOpen={isOpen}
      isSubmitting={isLoading}
      mode="CREATE"
      mutate={mutate}
      projectId={projectId}
      requiredFields={requiredFields}
      setIsOpen={setIsOpen}
      title={
        isPerM2
          ? t("Modernization.wizard.newMeasureForm.titlePerM2") || ""
          : t("Modernization.wizard.newMeasureForm.title") || ""
      }
    />
  );
};

export default CreatRetrofitMeasureForm;
